var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2970FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.175 13.245h3.392c1.213-.008 2.283-.986 2.279-2.223c.004-1.237-1.066-2.443-2.28-2.45h-1.081l-2.31-1.715h3.392c.996.004 1.96.34 2.727.954a4.12 4.12 0 0 1 1.478 2.41c.195.95.042 1.937-.43 2.784a4.27 4.27 0 0 1-2.164 1.885l2.679 2.253h-3.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44 10.714h3.377L8.212 6.857h-3.07l2.68 2.253a4.27 4.27 0 0 0-2.16 1.883c-.969 1.738-.502 3.958 1.044 5.195a4.4 4.4 0 0 0 2.734.955h3.385l-2.31-1.714H9.44c-1.541-.005-2.743-1.82-2.115-3.3c.341-.803 1.233-1.412 2.115-1.415"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcr);
export default __webpack_public_path__ + "static/media/dcr.0f825308234d65a7247220bab6e2bc39.svg";
export { ForwardRef as ReactComponent };